import copy from "@/services/copy";
import _ from "lodash";
export default function makeNavigationGuard(options = {}) {

    const {
        mapper = {},
        item = "item",
        dialog = "confirm-navigation"
    } = options;
    function mapDefaut(value) {
        return value;
    }

    return {
        beforeRouteLeave(to, from, next) {
            const eq = this.isSnapshotUnchanged();
            if (eq) {
                next();
            } else {
                this.$refs[dialog].ouvre(next);
            }
        },
        data() {
            return {
                navigation: {
                    snapshot: null
                },
            };
        },
        methods: {
            isSnapshotUnchanged() {
                const snapshot = this.takeSnapshot();
                const oldSnapshot = this.navigation.snapshot;
                return _.isEqual(snapshot, oldSnapshot);
            },
            initSnapshot() {
                this.navigation.snapshot = this.takeSnapshot();
            },
            takeSnapshot() {
                const out = [];
                const copyed = copy(this[item]);
                const keys = Object.keys(copyed).sort();
                for (const key of keys) {
                    const mapTo = mapper[key] || mapDefaut;
                    const oldValue = copyed[key];
                    const value = oldValue !== null ? mapTo(copyed[key]) : null;
                    out.push([key, value]);
                }
                return out;
            }
        }
    }
}
